export default ({request}) => ({
    sysMessageTemplateListApi(data = {}) {
      return request({
        url: '/sys/messageTemplate/list',
        method: 'post',
        data,
      })
    },
    sysMessageTemplateDetailApi(data = {}) {
      return request({
        url: '/sys/messageTemplate/detail',
        method: 'post',
        data,
      })
    },
    sysMessageTemplateSaveApi(data = {}) {
      return request({
        url: '/sys/messageTemplate/save',
        method: 'post',
        data,
      })
    },
    sysMessageTemplateCopyApi(data = {}) {
      return request({
        url: '/sys/messageTemplate/copy',
        method: 'post',
        data,
      })
    },
    sysMessageTemplateDelApi(data = {}) {
      return request({
        url: '/sys/messageTemplate/del',
        method: 'post',
        data,
      })
    },
    sysMessageSubscribeSaveApi(data = {}) {
      return request({
        url: '/sys/messageSubscribe/save',
        method: 'post',
        data,
      })
    },
    sysMessageSubscribeDetailApi(param = {}) {
      return request({
        url: `/sys/messageSubscribe/detail/${param.templateId}`,
        method: 'get',
      })
    },
  })
  